import { t } from "@lingui/macro";
import { getTranslatedText } from "@root/utils/ui";

// For each new test, these should be extended.

export type StepLabel = {
  label: string;
  /** An indicator for what kind of step we're doing.
   * - introduction: introduction for the first part.
   * - introduction2: introduction for the second test part.
   * - practise: a practise is being done.
   * - test: a test being done. Used when there is only one test in the game.
   * - test1: the first part of the test is being done.
   * - test2: the second part of the test is being done.
   * - end: final screens of a game.
   */
  kind: "introduction" | "instruction2" | "practise" | "test" | "test1" | "test2" | "end";
};
/* Steps Gbd */
export enum ProgressStateGbd {
  Introduction = "Introduction",
  Instruction = "Instruction",
  Practise = "Practise",
  Test = "Test",
  End = "End",
}
export const returnEnumIndexGbd = (val: ProgressStateGbd): number =>
  Object.keys(ProgressStateGbd).indexOf(val);

export const stepLabelsGbd: StepLabel[] = [
  { label: "gbd.progress.introduction", kind: "introduction" },
  { label: "gbd.progress.instruction", kind: "introduction" },
  { label: "gbd.progress.practise", kind: "practise" },
  { label: "gbd.progress.test", kind: "test" },
  { label: "gbd.progress.final", kind: "end" },
];

/* Gbd */

export const rowAmount = 10;
export const columnAmount = 17;

/* Steps Adm */
export enum ProgressStateAdm {
  Introduction = "Introduction", // Testinstructies
  InstructionPart1 = "InstructionPart1", // Testinstructies
  PractisePart1 = "PractisePart1", // Oefentest deel 1
  TestPart1 = "TestPart1", // Eerste testdeel
  InstructionPart2 = "InstructionPart2", // Testinstructies deel twee
  PractisePart2 = "PractisePart2",
  TestPart2 = "TestPart2",
  End = "End", // Insturen resultaten
}
export const returnEnumIndexAdm = (val: ProgressStateAdm): number =>
  Object.keys(ProgressStateAdm).indexOf(val);
export const stepLabelsAdm: StepLabel[] = [
  { label: "adm.progress.introduction", kind: "introduction" },
  { label: "adm.progress.instruction.part1", kind: "introduction" },
  { label: "adm.progress.practise.part1", kind: "practise" },
  { label: "adm.progress.test.part1", kind: "test1" },
  { label: "adm.progress.instruction.part2", kind: "instruction2" },
  { label: "adm.progress.practise.part2", kind: "practise" },
  { label: "adm.progress.test.part2", kind: "test2" },
  { label: "adm.progress.final", kind: "end" },
];

/* Dtg */
export enum ProgressStateDtg {
  Introduction = "Introduction",
  InstructionPart1Page1 = "InstructionPart1Page1",
  OnLocationSoundInstruction = "OnLocationSoundInstruction",
  OnLocationSoundPractise = "OnLocationSoundPractise",
  OnLocationColorInstruction = "OnLocationColorInstruction",
  OnLocationColorPractise = "OnLocationColorPractise",
  OnLocationPedalInstruction = "OnLocationPedalInstruction",
  OnLocationPedalPractise = "OnLocationPedalPractise",
  OnLocationFinalInstruction = "OnLocationFinalInstruction",
  InstructionPart1Page2 = "InstructionPart1Page2",
  PractisePart1 = "PractisePart1",
  TestPart1 = "TestPart1",
  InstructionPart2 = "InstructionPart2",
  // PractisePart2 = 'PractisePart2',
  TestPart2 = "TestPart2",
  End = "End",
}
export const returnEnumIndexDtg = (val: ProgressStateDtg): number =>
  Object.keys(ProgressStateDtg).indexOf(val);

const dtgHomeStates = [
  ProgressStateDtg.Introduction,
  ProgressStateDtg.InstructionPart1Page1,
  ProgressStateDtg.InstructionPart1Page2,
  ProgressStateDtg.PractisePart1,
  ProgressStateDtg.TestPart1,
  ProgressStateDtg.InstructionPart2,
  ProgressStateDtg.TestPart2,
  ProgressStateDtg.End,
];
export const returnEnumIndexDtgHome = (val: ProgressStateDtg): number => dtgHomeStates.indexOf(val);
export const stepLabelsDtgHome: StepLabel[] = [
  { label: "dtg.progress.introduction", kind: "introduction" },
  { label: "dtg.progress.instruction.part1.page1", kind: "introduction" },
  { label: "dtg.progress.instruction.part1.page2", kind: "introduction" },
  { label: "dtg.progress.practise.part1", kind: "practise" },
  { label: "dtg.progress.test.part1", kind: "test1" },
  { label: "dtg.progress.instruction.part2", kind: "instruction2" },
  { label: "dtg.progress.test.part2", kind: "test2" },
  { label: "dtg.progress.final", kind: "end" },
];

export const stepLabelsDtg: StepLabel[] = [
  { label: "dtg.progress.introduction", kind: "introduction" },
  { label: "dtg.progress.instruction.part1.page1", kind: "introduction" },
  { label: "dtg.progress.on-location.instruction.sound", kind: "introduction" },
  { label: "dtg.progress.on-location.practise.sound", kind: "practise" },
  { label: "dtg.progress.on-location.instruction.color", kind: "introduction" },
  { label: "dtg.progress.on-location.practise.color", kind: "practise" },
  { label: "dtg.progress.on-location.instruction.pedal", kind: "introduction" },
  { label: "dtg.progress.on-location.practise.pedal", kind: "practise" },
  { label: "dtg.progress.on-location.instruction.final", kind: "introduction" },
  { label: "dtg.progress.instruction.part1.page2", kind: "introduction" },
  { label: "dtg.progress.practise.part1", kind: "practise" },
  { label: "dtg.progress.test.part1", kind: "test1" },
  { label: "dtg.progress.instruction.part2", kind: "instruction2" },
  { label: "dtg.progress.test.part2", kind: "test2" },
  { label: "dtg.progress.final", kind: "end" },
];

/* Vda */
export enum ProgressStateVda {
  Introduction = "Introduction",
  InstructionPart1 = "InstructionPart1",
  InstructionPart2 = "InstructionPart2",
  InstructionPart3 = "InstructionPart3",
  InstructionPart4 = "InstructionPart4",
  Practise1 = "Practise1",
  Practise2 = "Practise2",
  Practise3 = "Practise3",
  Test = "Test",
  End = "End",
}
export const returnEnumIndexVda = (val: ProgressStateVda): number =>
  Object.keys(ProgressStateVda).indexOf(val);
export const stepLabelsVda: StepLabel[] = [
  { label: "vda.progress.introduction", kind: "introduction" },
  { label: "vda.progress.instruction.part1", kind: "introduction" },
  { label: "vda.progress.instruction.part2", kind: "introduction" },
  { label: "vda.progress.instruction.part3", kind: "introduction" },
  { label: "vda.progress.instruction.part4", kind: "introduction" },
  { label: "vda.progress.practise1", kind: "practise" },
  { label: "vda.progress.practise2", kind: "practise" },
  { label: "vda.progress.practise3", kind: "practise" },
  { label: "vda.progress.test", kind: "test" },
  { label: "vda.progress.final", kind: "end" },
];

interface StepperValues {
  labels: StepLabel[];
  index: number;
}
export const returnStepperValues = (
  variant: string,
  val: ProgressStateGbd | ProgressStateAdm | ProgressStateDtg | ProgressStateVda,
): StepperValues => {
  switch (variant) {
    case "adm":
      return {
        labels: stepLabelsAdm.map(({ label, kind }) => {
          return { label: getTranslatedText(label), kind };
        }),
        index: returnEnumIndexAdm(val as ProgressStateAdm),
      };
    case "gbd":
      return {
        labels: stepLabelsGbd.map(({ label, kind }) => {
          return { label: getTranslatedText(label), kind };
        }),
        index: returnEnumIndexGbd(val as ProgressStateGbd),
      };
    case "dtg-home":
      return {
        labels: stepLabelsDtgHome.map(({ label, kind }) => {
          return { label: getTranslatedText(label), kind };
        }),
        index: returnEnumIndexDtgHome(val as ProgressStateDtg),
      };
    case "dtg":
      return {
        labels: stepLabelsDtg.map(({ label, kind }) => {
          return { label: getTranslatedText(label), kind };
        }),
        index: returnEnumIndexDtg(val as ProgressStateDtg),
      };
    case "vda":
      return {
        labels: stepLabelsVda.map(({ label, kind }) => {
          return { label: getTranslatedText(label), kind };
        }),
        index: returnEnumIndexVda(val as ProgressStateVda),
      };
    default:
      return { labels: [{ label: "", kind: "end" }], index: -1 };
  }
};

// This is being used by all modals.
export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--color-neutral-100)",
  border: "1px solid",
  borderRadius: "24px",
  boxShadow: 24,
  color: "var(--color-brand-quaternary-500)",
  p: 0,
};

export interface ColorVariableStrings {
  red: string;
  yellow: string;
  blue: string;
  white: string;
  green: string;
}

export const returnColorVariable: ColorVariableStrings = {
  red: "var(--color-red-500)",
  yellow: "var(--color-yellow-500)",
  blue: "var(--color-blue-500)",
  white: "var(--color-white-100)",
  green: "var(--color-green-500)",
};

export const returnColorNicename: ColorVariableStrings = {
  red: t({
    id: "general.color.red",
    message: "rood",
  }),
  yellow: t({
    id: "general.color.yellow",
    message: "geel",
  }),
  blue: t({
    id: "general.color.blue",
    message: "blauw",
  }),
  white: t({
    id: "general.color.white",
    message: "wit",
  }),
  green: t({
    id: "general.color.green",
    message: "groen",
  }),
};
